module.exports = __webpack_public_path__ + "static/media/frame-green.44647b50.svg";